<div class="field" [ngClass]="{ 'mb-0': noMargin }" data-cy="form-field">
  <div class="flex justify-content-between align-items-center">
    <label
      *ngIf="label && type !== 'checkbox-binary'"
      for="{{ name }}"
      [ngClass]="{ 'required-label': isRequired }"
      [attr.data-cy]="label"
      ><span [ngClass]="{ 'font-semibold': boldLabel }" data-cy="label">{{ label }}</span
      ><span *ngIf="labelHint" data-cy="hint"> {{ labelHint }}</span></label
    >
    <div
      *ngIf="tooltip"
      class="p4 font-medium text-primary cursor-pointer"
      [pTooltip]="tooltip"
      tooltipPosition="top"
      tooltipEvent="focus"
      [tabindex]="0"
    >
      What's this?
    </div>
  </div>
  <div class="w-full" [style]="'max-width: ' + (limitWidth ? '320px' : '100%')">
    <div *ngIf="leftImageUrl === undefined && rightImageUrl === undefined" class="w-full">
      <ng-container *ngTemplateOutlet="controlOutlet"></ng-container>
    </div>

    <span *ngIf="leftImageUrl !== undefined" class="p-input-icon-left w-full">
      <i *ngIf="leftImageUrl" class="pi"
        ><img [src]="leftImageUrl" height="24px" data-cy="control-left-image" alt="Icon"
      /></i>
      <ng-container *ngTemplateOutlet="controlOutlet"></ng-container>
    </span>

    <span *ngIf="rightImageUrl !== undefined" class="p-input-icon-right w-full">
      <i *ngIf="rightImageUrl" class="pi"
        ><img [src]="rightImageUrl" height="24px" ata-cy="control-right-image" alt="Icon"
      /></i>
      <ng-container *ngTemplateOutlet="controlOutlet"></ng-container>
    </span>

    <div *ngIf="control.invalid && control.errors && (control.dirty || control.touched)">
      <!-- TODO Move to read from common definition of supported errors -->
      <!-- TODO Ensure covering all of the angular standard validators -->
      <small *ngIf="control.hasError('required')" class="p-error block" data-cy="error-required"
        >{{ errorLabel || label }} is required</small
      >
      <small *ngIf="control.hasError('invalid')" class="p-error block" data-cy="error-invalid"
        >{{ errorLabel || label }} is not valid</small
      >
      <small *ngIf="control.hasError('email')" class="p-error block" data-cy="error-invalid"
        >{{ errorLabel || label }} is not valid</small
      >
      <small *ngIf="control.hasError('minDate')" class="p-error block" data-cy="error-min-date"
        >{{ errorLabel || label }} is too old</small
      >
      <small *ngIf="control.hasError('maxDate')" class="p-error block" data-cy="error-max-date"
        >{{ errorLabel || label }} is too recent</small
      >
      <small *ngIf="control.hasError('maxlength')" class="p-error block" data-cy="error-max-length"
        >{{ errorLabel || label }} must not exceed {{ control.errors['maxlength'].requiredLength }} characters
        long</small
      >
      <small *ngIf="control.hasError('minlength')" class="p-error block" data-cy="error-min-length"
        >{{ errorLabel || label }} must be at least {{ control.errors['minlength'].requiredLength }} characters
        long</small
      >
      <small *ngIf="control.hasError('min')" class="p-error block" data-cy="error-max-date"
        >{{ errorLabel || label }} must be greater than or equal to {{ control.errors['min'].min }}</small
      >
      <small *ngIf="control.hasError('max')" class="p-error block" data-cy="error-max-date"
        >{{ errorLabel || label }} must be less than or equal to {{ control.errors['max'].max }}</small
      >
      <small *ngIf="control.hasError('minExclusive')" class="p-error block" data-cy="error-max-date"
        >{{ errorLabel || label }} must be greater than {{ control.errors['minExclusive'].min }}</small
      >
      <small *ngIf="control.hasError('notInteger')" class="p-error block" data-cy="error-invalid-integer"
        >{{ errorLabel || label }} is not a valid integer number</small
      >
      <small *ngIf="control.hasError('notDecimal')" class="p-error block" data-cy="error-invalid-decimal"
        >{{ errorLabel || label }} is not a valid decimal number</small
      >
      <small *ngIf="control.hasError('notPhone')" class="p-error block" data-cy="error-invalid-phone"
        >{{ errorLabel || label }} is not a valid phone number</small
      >
      <small
        *ngIf="control.hasError('passwordMismatch') && showNotMatchError"
        class="p-error block"
        data-cy="error-invalid-phone"
        >Passwords do not match</small
      >
      <small *ngIf="control.hasError('ccsEmail')" class="p-error block" data-cy="error-ccs-email"
        >CCSMed.com email addresses are not currently supported on the patient portal.</small
      >
    </div>
  </div>
</div>

<ng-template #controlOutlet>
  <ng-template [ngIf]="type === 'input' && !inputMask && inputType === 'password'">
    <p-password
      inputId="{{ name }}"
      class="w-full"
      styleClass="p-password p-component p-inputwrapper p-input-icon-right"
      [formControl]="control"
      [toggleMask]="toggleShowPassword"
      [feedback]="false"
      [attr.data-cy]="name"
      autocomplete="new-password"
    >
    </p-password>
  </ng-template>
  <ng-template
    [ngIf]="
      type === 'input' && !inputMask && inputType !== 'number' && inputType !== 'password' && inputMode !== 'numeric'
    "
  >
    <input
      pInputText
      id="{{ name }}"
      [type]="inputType"
      [attr.inputmode]="inputMode"
      [formControl]="control"
      [placeholder]="placeholder"
      class="inputfield w-full"
      autocomplete="on"
      [attr.data-cy]="name"
    />
  </ng-template>
  <ng-template
    [ngIf]="
      type === 'input' && !inputMask && inputType !== 'number' && inputType !== 'password' && inputMode === 'numeric'
    "
  >
    <input
      pInputText
      id="{{ name }}"
      [type]="inputType"
      [attr.inputmode]="inputMode"
      [formControl]="control"
      [placeholder]="placeholder"
      class="inputfield w-full"
      [style]="{ 'letter-spacing': '2px' }"
      [attr.data-cy]="name"
    />
  </ng-template>
  <ng-template [ngIf]="type === 'input' && !inputMask && inputType === 'number' && inputMode === 'numeric'">
    <p-inputNumber
      id="{{ name }}"
      inputStyleClass="inputfield w-full"
      [inputStyle]="{ 'letter-spacing': '2px' }"
      [formControl]="control"
      [placeholder]="placeholder"
      [attr.min]="min"
      [useGrouping]="false"
      [ariaLabel]="label || name"
      (onInput)="onNumberInput($event)"
      [attr.data-cy]="name"
    ></p-inputNumber>
  </ng-template>
  <ng-template [ngIf]="type === 'input' && !inputMask && inputType === 'number' && inputMode === 'decimal'">
    <p-inputNumber
      id="{{ name }}"
      inputStyleClass="inputfield w-full"
      [inputStyle]="{ 'letter-spacing': '2px' }"
      [formControl]="control"
      mode="decimal"
      [placeholder]="placeholder"
      [attr.min]="min"
      [minFractionDigits]="1"
      [maxFractionDigits]="2"
      [useGrouping]="false"
      [ariaLabel]="label || name"
      (onInput)="onNumberInput($event)"
      [attr.data-cy]="name"
    ></p-inputNumber>
  </ng-template>
  <ng-template [ngIf]="type === 'input' && !inputMask && inputType === 'number' && inputMode === 'currency'">
    <p-inputNumber
      id="{{ name }}"
      inputStyleClass="inputfield w-full"
      [inputStyle]="{ 'letter-spacing': '2px' }"
      [formControl]="control"
      mode="currency"
      [placeholder]="placeholder"
      currency="USD"
      locale="en-US"
      [attr.min]="min"
      [useGrouping]="true"
      [ariaLabel]="label || name"
      (onInput)="onNumberInput($event)"
      [attr.data-cy]="name"
    ></p-inputNumber>
  </ng-template>
  <ng-template [ngIf]="type === 'input' && inputMask">
    <p-inputMask
      id="{{ name }}"
      [type]="inputType"
      [attr.inputmode]="inputMode"
      [attr.min]="min"
      [style]="inputMode === 'numeric' ? { 'letter-spacing': '2px' } : {}"
      [formControl]="control"
      [placeholder]="placeholder"
      [mask]="inputMask"
      [autoClear]="false"
      [unmask]="true"
      styleClass="inputfield w-full"
      [autocomplete]="inputType === 'password' ? 'new-password' : 'on'"
      [attr.data-cy]="name"
    ></p-inputMask>
  </ng-template>
  <ng-template [ngIf]="type === 'dropdown'">
    <p-dropdown
      [options]="options"
      id="{{ name }}"
      [formControl]="control"
      [placeholder]="placeholder"
      appendTo="body"
      class="inputfield"
      styleClass="w-full"
      [attr.data-cy]="name"
    ></p-dropdown>
  </ng-template>
  <ng-template [ngIf]="type === 'multiselect'">
    <p-multiSelect
      [options]="options"
      id="{{ name }}"
      [formControl]="control"
      [placeholder]="placeholder"
      display="chip"
      appendTo="body"
      class="inputfield"
      styleClass="w-full"
      [attr.data-cy]="name"
    ></p-multiSelect>
  </ng-template>
  <ng-template [ngIf]="type === 'autocomplete'">
    <span class="p-input-icon-right w-full">
      <i *ngIf="!isLoading" class="pi pi-search z-5"></i>
      <p-autoComplete
        id="{{ name }}"
        [formControl]="control"
        [placeholder]="placeholder"
        [suggestions]="options"
        [multiple]="true"
        [showEmptyMessage]="options && options.length === 0"
        emptyMessage="No results found"
        field="label"
        (completeMethod)="completeMethod($event)"
        class="inputfield"
        styleClass="w-full"
        [attr.data-cy]="name"
      >
      </p-autoComplete>
    </span>
  </ng-template>
  <ng-template [ngIf]="type === 'calendar'">
    <p-calendar
      id="{{ name }}"
      [formControl]="control"
      [placeholder]="placeholder"
      appendTo="body"
      [showIcon]="true"
      [selectOtherMonths]="true"
      [showOnFocus]="false"
      class="inputfield"
      styleClass="w-full"
      iconAriaLabel="Open Calendar"
      [attr.data-cy]="name"
    ></p-calendar>
  </ng-template>
  <ng-template [ngIf]="type === 'radio' && !horizontalLayout">
    <div class="mt-2">
      <p-radioButton
        *ngFor="let option of options"
        [name]="name"
        [label]="option.label"
        [value]="option.value"
        [formControl]="control"
        class="field-radiobutton"
        [ngClass]="{ 'mb-3': !noMargin, 'mb-0': noMargin }"
        [ariaLabel]="option.label"
        [attr.data-cy]="name + '-' + option.label"
      ></p-radioButton>
    </div>
  </ng-template>
  <ng-template [ngIf]="type === 'radio' && horizontalLayout">
    <div class="formgroup-inline mt-2">
      <p-radioButton
        *ngFor="let option of options"
        [name]="name"
        [label]="option.label"
        [value]="option.value"
        [formControl]="control"
        class="field-radiobutton mb-0"
        [ariaLabel]="option.label"
        [attr.data-cy]="name + '-' + option.label"
      ></p-radioButton>
    </div>
  </ng-template>
  <ng-template [ngIf]="type === 'selectbutton'">
    <p-selectButton [options]="options" id="{{ name }}" [formControl]="control" [attr.data-cy]="name"></p-selectButton>
  </ng-template>
  <ng-template [ngIf]="type === 'checkbox'">
    <div class="mt-2">
      <p-checkbox
        *ngFor="let option of options"
        [label]="option.label"
        [value]="option.value"
        [formControl]="control"
        class="field-checkbox"
        [ngClass]="noCheckboxMargin ? 'mb-0' : small ? 'mb-1' : 'mb-3'"
        [styleClass]="small ? 'p-checkbox-sm' : ''"
        [ariaLabel]="option.label"
        [attr.data-cy]="name + '-' + option.label"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template [ngIf]="type === 'checkbox-binary'">
    <div class="flex align-items-start">
      <p-checkbox
        [formControl]="control"
        [binary]="true"
        [trueValue]="true"
        [falseValue]="false"
        [class]="noCheckboxMargin ? 'field-checkbox mb-0' : 'field-checkbox mb-3'"
        [ariaLabel]="label || name"
        [attr.data-cy]="name"
      ></p-checkbox>
      <label
        for="{{ name }}"
        class="p-checkbox-label"
        [ngClass]="{ 'required-label': isRequired }"
        [attr.data-cy]="label"
      >
        {{ label }}
        <ng-content></ng-content>
      </label>
    </div>
  </ng-template>
  <ng-template [ngIf]="type === 'textarea'">
    <textarea
      pInputTextarea
      id="{{ name }}"
      [attr.inputmode]="inputMode"
      [formControl]="control"
      [placeholder]="placeholder"
      [autoResize]="true"
      [rows]="5"
      [cols]="30"
      class="inputfield w-full"
      autocomplete="on"
      [attr.data-cy]="name"
    ></textarea>
    <div *ngIf="characterLimit" class="textarea-count-container">
      <span class="textarea-count" [ngClass]="{ 'p-error': (characterCount || 0) > (characterLimit || 0) }"
        >{{ characterCount }}/{{ characterLimit }}</span
      >
    </div>
  </ng-template>
</ng-template>
